var XPortal = XPortal || {};
XPortal.Measure = (function () {
    var self = {
        ControlSelector: ".measure-control",
        Init: function (container) {
            container = container ? container : $(XPortal.Main.DetialFormSelector);
            container.find(XPortal.Measure.ControlSelector).each(function (i, element) {
                if (!$(element).hasClass('k-gauge')) {
                    XPortal.Measure.initFor(element);
                }
            });
        },
        initFor: function (element) {
            var el = jQuery(element);
            var opt = {
                pointer: [], 
                scale: {
                    rangePlaceholderColor: '#dedede',
                    minorTicks: { color: '#c8d2e2' },
                    majorTicks: { color: '#8c9aab' },
                    line: { color: '#434343' },
                    minorUnit: 2,
                    max: 100,
                    min: 0,
                    color: 'blue',
                    labels: {
                        color: '#626f7c',
                        position: "inside"
                    },
                    ranges: [
                        {
                            from: 0,
                            to: 25,
                            color: "#00a47c"
                        }, {
                            from: 25,
                            to: 50,
                            color: "#ffcf60"
                        },
                        {
                            from: 50,
                            to: 75,
                            color: "#ff9f20"
                        },
                        {
                            from: 75,
                            to: 100,
                            color: "#f45234"
                        }
                    ]
                }
            };
            el.find(".measure-point").each(function () {
                var $p = $(this);
                opt.pointer.push({ value: Number($p.attr("data-value")), color: '#007BFF', length: 0.6, cap: { size: 0.1 } });
            });
            var type = el.attr("data-type");
            el.kendoRadialGauge(opt);
            window.addResizeListener(el[0], function () {
                XPortal.Measure.resize(el);
            });
            $(window).on('resize orientationchange', function () {
                if (el.resizeInterval > 0) clearTimeout(el.resizeInterval);
                el.resizeInterval = setTimeout(function () {
                    XPortal.Measure.resize(el);
                }, 50);
            });
            XPortal.Measure.resize(el);
        },
        reInit: function ($wrapper) {
            $measures = $wrapper.find('.measure-control');

            if (!$measures.length) {
                return;
            }

            XPortal.Measure.Init($wrapper);

            setTimeout(function () {
                $measures.each(function () {
                    XPortal.Measure.resize($(this));
                });
            }, 0);
        },
        resize: function (el) {
            var w = el.parent().width() - 2;
            el.width(w);
            el.height(w);
            var gc = el.data("kendoRadialGauge");
            if (gc) {
                gc.resize();
                el.parent().height(w);
                gc.options.scale.labels.visible = w > 150;
                gc.options.scale.minorUnit = w > 150 ? 2 : (w > 200 ? 5 : 10),
                    gc.redraw();
            }
        }
    };
    return self;
}());